<template>
  <section class="rewards-card__box my-0 my-lg-4">
    <div class="rewards-card__title p-4" @click="toogleDropdown">
      <h1>{{ translate('rdWhySelectMemberOnlyRate') }}</h1>
      <div class="d-flex ml-3">
        <img :src="img" alt="logo" />
        <i
          class="d-block d-lg-none xs"
          :class="showBenefits ? 'icon-arrow-up' : 'icon-arrow-down'"
        ></i>
      </div>
    </div>
    <div class="rewards-card__benefits pt-3" v-if="showBenefits">
      <h3 class="px-4 font-weight-bold">{{ benefits.title }}</h3>
      <div class="rewards-card__benefits__content p-4">
        <ul>
          <li
            class="d-flex align-items-center mt-1"
            v-for="(benefit, index) in maxBenefits"
            :key="index"
          >
            <i :class="`icon-${benefit.icon} sm ${benefitsNlp}`"></i>
            <span class="pl-3">{{ benefit.title }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { isMobileDevice } from '../../../infrastructure/Utils'
import { assetsUrl } from '../../../infrastructure/Configuration'

export default {
  name: 'MembersBenefits',
  props: {
    benefits: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    img: `${assetsUrl}/svg/radisson-rewardsnewicon.svg`,
    isMobile: isMobileDevice(),
    showBenefitsMobile: false,
    showBenefitsDesktop: true
  }),
  computed: {
    showBenefits: function () {
      return this.isMobile ? this.showBenefitsMobile : this.showBenefitsDesktop
    },
    maxBenefits: function () {
      return this.benefits.benefits.slice(0, 3)
    },
    benefitsNlp: function () {
      return 'color-nlp'
    }
  },
  methods: {
    reportWindowSize() {
      const innerWidth = window.innerWidth
      innerWidth <= 991 ? (this.isMobile = true) : (this.isMobile = false)
    },
    toogleDropdown() {
      if (this.isMobile) {
        this.showBenefitsMobile = !this.showBenefitsMobile
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.reportWindowSize)
  }
}
</script>

<style lang="scss" scoped>
.rewards-card {
  &__box {
    color: #53565a;
    border-top: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    background-color: #fff;
    margin-top: 3rem;
    border-radius: 8px;
    @media (min-width: 992px) {
      border: 1px solid #d8d8d8;
    }
  }
  &__title {
    font-size: 1.5rem;
    font-weight: bold;
    align-items: center;
    display: flex;
    justify-content: space-between;
    img {
      width: 70px;
    }
    i {
      color: #c20808;
      cursor: pointer;
    }
    &__benefits {
      border-top: 1px solid #d8d8d8;
      &__content {
        line-height: 3rem;
      }
    }
  }
}
.color {
  color: #80b722;
}

.color-nlp {
  color: #382246;
}

html[dir='rtl'] {
  .rewards-card {
    &__box {
      text-align: right;
    }
  }
}
</style>
